var FileCategories;
(function (FileCategories) {
    FileCategories["JPG"] = "jpg";
    FileCategories["JPEG"] = "jpeg";
    FileCategories["PNG"] = "png";
    FileCategories["GIF"] = "gif";
    FileCategories["PDF"] = "pdf";
})(FileCategories || (FileCategories = {}));
var FileMimeCategories;
(function (FileMimeCategories) {
    FileMimeCategories["JPG"] = "image/jpg";
    FileMimeCategories["JPEG"] = "image/jpeg";
    FileMimeCategories["PNG"] = "image/png";
    FileMimeCategories["GIF"] = "image/gif";
    FileMimeCategories["PDF"] = "application/pdf";
})(FileMimeCategories || (FileMimeCategories = {}));

export { FileCategories, FileMimeCategories };
//# sourceMappingURL=files.js.map
